import { State } from 'xstate';
import { undoCancelation } from './undoCancelation';

type UndoCancelationMachine = typeof undoCancelation;
type UndoCancelationState = State<UndoCancelationMachine['context']>;

export const getUndoCancelationStatus = (
  machineState: UndoCancelationState
) => ({
  idle: machineState.matches('idle'),
  undoCancelationLoading: machineState.matches('undoCancelation'),
  undoCancelationSuccess: machineState.matches('success'),
  undoCancelationError: machineState.matches('error'),
});

export const getErrorCode = (machineState: UndoCancelationState) => {
  return machineState.context.error;
};

export const undoCancelationSelectors = {
  getUndoCancelationStatus,
  getErrorCode,
};
